import parseJwt from './parseJwt';

export default parseJwt;
